import http from '../axios';

export function create(operation_captain_detail){
  return http.post('/operation_captain_details', {operation_captain_detail});
}

export function show(id) {
  return http.get(`/operation_captain_details/${id}`);
}
